import React from "react";
import _ from "lodash";
import Checkbox from "components/common/Checkbox";
import DateTimeFormatter from "components/common/DateTimeFormatter";
import StatusLabel from "components/ops-mgmt/account/publishers/gam-accounts/StatusLabel";
import YiedlSetModal from "components/ops-mgmt/account/publishers/gam-accounts/YieldSetModal";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";
import { OnboardingAPI } from "apis";

import { thClass, tdClass, buttonConfirmClass } from "helpers/StyleClass.js";

const STATUS = {
  RUNNING: "RUNNING",
  PAUSED: "PAUSED",
};

class OnboardYieldSet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isYieldSetModalOpen: false,

      yieldSets: [],
      adxAccounts: [],

      selected: this.props.selectedYieldSet
        ? this.props.selectedYieldSet.yieldSetId
        : null,
    };

    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleUpdateYieldSet = this.handleUpdateYieldSet.bind(this);
    this.handleUpdateAdxAccount = this.handleUpdateAdxAccount.bind(this);
  }

  async componentDidMount() {
    this.props.handleLoading(true);

    const { networkId } = this.props;
    const { selected } = this.state;

    try {
      const result = await OnboardingAPI.getYieldSetsWithUnitSummary({
        networkId,
      });

      const adxAccounts = await OnboardingAPI.getAdxAccounts({ networkId });

      this.setState(
        { yieldSets: result || [], adxAccounts: adxAccounts || [] },
        () => {
          const { yieldSets } = this.state;
          if (yieldSets && yieldSets.length === 1 && !selected) {
            this.handleCheckChange(yieldSets[0].yieldSetId);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }

    this.props.handleLoading(false);
  }

  handleCheckChange(yieldSetId) {
    const { selected, yieldSets } = this.state;
    const changed = selected === yieldSetId ? null : yieldSetId;
    this.setState({
      selected: changed,
    });

    const yieldSet = yieldSets.find((item) => item.yieldSetId === changed);
    this.props.handleChange(yieldSet);
  }

  handleUpdateYieldSet(yieldSet) {
    this.setState(
      (prevState) => ({
        yieldSets: [...prevState.yieldSets, yieldSet],
      }),
      () => {
        this.handleCheckChange(yieldSet.yieldSetId);
      }
    );
  }

  handleUpdateAdxAccount(data) {
    this.setState((prevState) => ({
      adxAccounts: [...prevState.adxAccounts, data],
    }));
  }

  render() {
    const { networkId } = this.props;
    const { yieldSets, selected, isYieldSetModalOpen, adxAccounts } =
      this.state;

    return (
      <div>
        <div className="mb-2 flex justify-end">
          <button
            className={buttonConfirmClass}
            onClick={() => this.setState({ isYieldSetModalOpen: true })}
          >
            Add Yield Set
          </button>
        </div>
        <table className="shadow divide-y min-w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className={`${thClass}`} style={{ width: "2rem" }}></th>
              <th className={`${thClass} w-32`}>Yield Set ID</th>
              <th className={`${thClass} w-48`}>Name</th>
              <th className={`${thClass} w-40`}>Adx Account</th>
              <th className={`${thClass} w-32`}>Status</th>
              <th className={thClass}>GAM Ad Units</th>
              <th className={`${thClass} w-48`}>Create At</th>
              <th className={`${thClass} w-48`}>Update At</th>
            </tr>
          </thead>
          <tbody className="divide-y bg-white text-sm">
            {yieldSets.map((item, idx) => (
              <HighLightRowWrapper
                selected={selected === item.yieldSetId}
                key={`${item.yieldSetId}-${idx}`}
                onClick={() => {
                  this.handleCheckChange(item.yieldSetId);
                }}
              >
                <td className={tdClass}>
                  <Checkbox
                    isChecked={selected === item.yieldSetId}
                    onChange={() => {
                      this.handleCheckChange(item.yieldSetId);
                    }}
                  ></Checkbox>
                </td>
                <td className={tdClass}>{item.yieldSetId}</td>
                <td className={`${tdClass} break-all`}>{item.name}</td>
                <td className={tdClass}>{item.adxAccount.name}</td>
                <td
                  className={`${tdClass} ${
                    item.status === STATUS.RUNNING
                      ? "text-green-500"
                      : "text-gray-500"
                  } font-semibold`}
                >
                  {item.status}
                </td>
                <td className={tdClass}>
                  {item.adUnitCountByStatus && (
                    <div className="flex flex-wrap gap-2">
                      {_.keys(STATUS).map((status) => (
                        <StatusLabel
                          key={status}
                          status={status}
                          count={item.adUnitCountByStatus[status]}
                        ></StatusLabel>
                      ))}
                    </div>
                  )}
                </td>
                <td className={tdClass}>
                  <DateTimeFormatter
                    datetime={item.createdAt}
                    isLineBreak={true}
                  ></DateTimeFormatter>
                </td>
                <td className={tdClass}>
                  <DateTimeFormatter
                    datetime={item.updatedAt}
                    isLineBreak={true}
                  ></DateTimeFormatter>
                </td>
              </HighLightRowWrapper>
            ))}
          </tbody>
        </table>

        {isYieldSetModalOpen && (
          <YiedlSetModal
            networkId={networkId}
            adxAccounts={adxAccounts}
            selectedYieldSet={null}
            onLoading={(isLoading) => this.props.handleLoading(isLoading)}
            onCancel={() => this.setState({ isYieldSetModalOpen: false })}
            onClose={(data) => {
              this.setState({ isYieldSetModalOpen: false });
              this.handleUpdateYieldSet(data);
            }}
            onAddAdxAccount={(data) => this.handleUpdateAdxAccount(data)}
          ></YiedlSetModal>
        )}
      </div>
    );
  }
}
export default OnboardYieldSet;
